import React, { Component } from 'react'
import { FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl'
import { each, uniqueId } from 'lodash'

import { callApi, API_ROOT, getAuthHeaders } from '../services/fetchService'

import FaIcon from '../components/FaIcon'
import HelpAlert from '../components/HelpAlert'

import { Button, Card, Upload, Spin, message } from 'antd'



class SettingsOther extends Component {

    state = {
        fileList: [],
        loading: false
    }

    static propTypes = {
        intl: intlShape.isRequired
    }

    fetch = (params = {}) => {
        const { intl } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'uploads'
        }).then((data) => {
            this.setState({
                fileList: each(data, (item) => {
                    item.uid = uniqueId()
                    item.status = 'done'
                }),
                loading: false
            })
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    componentDidMount() {
        this.fetch()
    }

    handleChange = (info) => {
        const { intl } = this.props
        let fileList = info.fileList;

        fileList = fileList.map((file) => {
            if (file.response) {
                file.url = file.response.url
                file.filename = file.response.filename
            }
            return file
        })
        if (info.file.status === 'done') {
            message.success(intl.formatMessage({id: 'settings.other.fileUploadSuccess'}))
        } else if (info.file.status === 'error') {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
        } else if (info.file.status === 'removed') {
            if (!info.file.error) {
                callApi({
                    endpoint: 'uploads/' + info.file.filename,
                    method: 'DELETE'
                }).then((data) => {
                    message.success(intl.formatMessage({id: 'misc.deleteSuccess'}))
                }).catch((data) => {
                    message.error(intl.formatMessage({id: 'misc.unknownError'}))
                    info.file.status = 'done'
                    const newList = this.state.fileList.slice()
                    newList.push(info.file)
                    this.setState({ fileList: newList})
                })
            }
        }
        this.setState({ fileList })
    }

    /**
     * Render view
     */
    render() {
        const { loading } = this.state

        const uploadProps = {
            name: 'file',
            action: API_ROOT + 'uploads',
            headers: getAuthHeaders(),
            onChange: this.handleChange,
            fileList: this.state.fileList,
            multiple: true
        }

        return (
            <div>
                <h1><FaIcon icon="cogs" fixedWidth /> <FormattedHTMLMessage id="settings.other.title" /></h1>
                <Spin spinning={loading}>
                    <Card title={<span><FaIcon icon="file" /><FormattedMessage id="settings.other.helpFiles" /></span>}>
                        <HelpAlert style={{ marginBottom: '24px' }} message="settings.other.helpFilesAlert" />
                        <Upload { ...uploadProps }>
                            <Button><FaIcon icon="upload" /> <FormattedMessage id="misc.clickToUpload" /></Button>
                        </Upload>
                    </Card>
                </Spin>
            </div>
        )
    }

}

export default injectIntl(SettingsOther)


// WEBPACK FOOTER //
// ./src/views/SettingsOther.js